/**
 * Supported fills.
 * @type {Object<String>}
 */
export const FILLS = {
    FULL: 'full',
    GHOST: 'ghost'
};

/**
 * Supported themes.
 * @type {Object<String>}
 */
export const THEMES = {
    INFORMATION: 'information',
    WARNING: 'warning',
    SUCCESS: 'success',
    FAILURE: 'failure'
};

/**
 * Supported modes.
 * @type {Object<String>}
 */
export const MODES = {
    LIGHT: 'light',
    DARK: 'dark'
};
